export default "__VITE_ASSET__DzeVaKUx__"